import jQuery from 'jquery';
import clamp from 'clamp-js';

(function ($) {
    const $textOverlays = $('.text-overlay-content');

    const clampDescription = () => {
        $textOverlays.each((_, element) => {
            clamp(element, { clamp: 5 });
        });
    };

    const debounce = (func, delay) => {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    };

    if ($textOverlays.length) {
        clampDescription();
        $(window).on('resize', debounce(clampDescription, 200));
    }
})(jQuery);
